import { render } from "./FooterView.vue?vue&type=template&id=4b66b950"
import script from "./FooterView.vue?vue&type=script&lang=js"
export * from "./FooterView.vue?vue&type=script&lang=js"

import "./FooterView.vue?vue&type=style&index=0&id=4b66b950&lang=css"

import exportComponent from "C:\\Users\\randy\\Documents\\Développement\\my-portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__